import React from "react";
import "../../styles/styles.scss";
import moment from "moment";
import { FormattedMessage } from "react-intl";
import config from "react-global-configuration";
import ShowMoreText from "react-show-more-text";
import { getEndIndex, getPageLinks } from "./pages";
import FeedbackHeader from "./FeedbackHeader";

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);

const importAll = (r) => {
  let images = {};
  r.forEach((item) => {
    let start = item.lastIndexOf("/") + 1;
    let end = item.lastIndexOf(".");
    images[item.substring(start, end)] = item;
  });
  return images;
};

const flags = importAll(
  requireAll(require.context("../../assets/img/country", true, /.+\.png$/))
);
const ratings = importAll(
  requireAll(require.context("../../assets/img/rating", true, /.+\.png$/))
);

const renderCategory = (feedback, params) => {
  return (
    <>
      {params.editedCategory !== feedback.id && (
        <FormattedMessage
          id={"app.feedback.category." + feedback.categoryCode}
          defaultMessage="unknown"
        />
      )}
      {params.role === config.get("adminRole") &&
        params.editedCategory === feedback.id && (
        <>
          <select
            onChange={(event) => params.changeCategory(event.target.value)}
            value={params.newCategory}
            style={{ width: "100%" }}
          >
            {params.categories &&
                params.categories.map((category, i) => (
                  <FormattedMessage
                    id={"app.feedback.category." + category.categoryCode}
                    defaultMessage="unknown"
                    key={i}
                  >
                    {(message) => (
                      <option value={category.categoryCode}>{message}</option>
                    )}
                  </FormattedMessage>
                ))}
          </select>
          <span
            className="spanButton red"
            onClick={() => params.cancelCategory()}
          >
            ✗
          </span>
          <span
            className="spanButton green"
            onClick={() => params.updateCategory()}
          >
            ✓
          </span>
        </>
      )}
      {params.role === config.get("adminRole") &&
        params.editedCategory !== feedback.id && (
        <span
          style={{ cursor: "pointer", float: "right" }}
          onClick={() =>
            params.editCategory(feedback.id, feedback.categoryCode)
          }
        >
          ✏
        </span>
      )}
    </>
  );
};

const Feedback = (params) => {
  const startIndex = params.count === 0 ? 0 : params.page * params.paging + 1;
  const endIndex = getEndIndex(params.page, params.paging, params.count);
  const pageLinks = getPageLinks(
    params.page,
    params.paging,
    params.count,
    params.intl
  );

  return (
    <div>
      <div className="row" style={{ minHeight: "350px", overflowX: "auto" }}>
        <div className="col-sm-12">
          <table
            className="table table-striped dataTable no-footer"
            id="feedbackTable"
            role="grid"
            aria-describedby="feedbackTable_info"
          >
            <FeedbackHeader
              sortBy={params.sortBy}
              sortDirection={params.sortDirection}
              intl={params.intl}
              categories={params.categories}
              selectedCategories={params.selectedCategories}
              selectCategory={params.selectCategory}
              reload={params.reload}
              withComment={params.withComment}
              selectComment={params.selectComment}
              withReaction={params.withReaction}
              selectReaction={params.selectReaction}
            />
            <tbody>
              {params.feedbackList &&
              params.feedbackList.map((feedback, i) => (
                <tr
                  role="row"
                  className="odd"
                  key={"row" + i}
                  {...(feedback.deactivated === true
                    ? {
                      title: params.intl.formatMessage({
                        id: "app.feedback.deactivated",
                      }),
                    }
                    : {})}
                >
                  <td>{feedback.sequenceNumber}</td>
                  <td className="text-center">
                    <img
                      className="mt-1"
                      src={ratings[feedback.rating]}
                      width="30"
                    />
                  </td>
                  <td>
                    <strong className="d-block text-gray-dark">
                      {feedback.user.email}
                    </strong>
                  </td>
                  <td className="text-center">
                    <img
                      className="mt-1"
                      src={flags[feedback.countryCode.toLowerCase()]}
                      width="30"
                      title={feedback.countryCode.toUpperCase()}
                    />
                  </td>
                  <td className="sorting_1">
                    {moment(feedback.createdAt).format("D. M. YYYY HH:mm")}
                  </td>
                  <td>
                    {feedback.vehicle.model &&
                      feedback.vehicle.manufacturingDate &&
                      feedback.vehicle.model +
                      " (" +
                      moment(feedback.vehicle.manufacturingDate).format(
                        "YYYY"
                      ) +
                      ")"}
                  </td>
                  <td>{feedback.vin}</td>
                  <td className="category">
                    {renderCategory(feedback, params)}
                  </td>
                  <td className="comment">
                    <ShowMoreText
                      lines={3}
                      more={params.intl.formatMessage({
                        id: "app.feedback.long.text.more",
                      })}
                      less={params.intl.formatMessage({
                        id: "app.feedback.long.text.less",
                      })}
                    >
                      {feedback.comment}
                    </ShowMoreText>
                  </td>
                  <td className="comment">
                    {feedback.createdBySkodaEmployee &&
                      !feedback.adminReaction &&
                      params.role !== config.get("readerRole") && (
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-xs"
                        data-toggle="modal"
                        disabled={feedback.deactivated === true}
                        onClick={() => params.addReaction(feedback.id)}
                      >
                        <FormattedMessage id="app.feedback.reaction.header.add" />
                      </button>
                    )}
                    {feedback.adminReaction && (
                      <>
                        <ShowMoreText
                          lines={2}
                          more={params.intl.formatMessage({
                            id: "app.feedback.long.text.more",
                          })}
                          less={params.intl.formatMessage({
                            id: "app.feedback.long.text.less",
                          })}
                        >
                          {feedback.adminReaction}
                        </ShowMoreText>
                        {params.role !== config.get("readerRole") &&
                          !feedback.deactivated && (
                          <>
                            <span
                              className="spanButton"
                              onClick={() =>
                                params.editReaction(
                                  feedback.id,
                                  feedback.adminReaction
                                )
                              }
                            >
                                ✏
                            </span>
                            <span
                              className="spanButton red"
                              onClick={() =>
                                params.deleteReaction(
                                  feedback.id,
                                  feedback.adminReaction
                                )
                              }
                            >
                                🗑
                            </span>
                          </>
                        )}
                      </>
                    )}
                  </td>
                  <td>
                    {feedback.attachments &&
                      feedback.attachments.map((attachment, j) => (
                        <p
                          key={"link_" + i + "_" + j}
                          className="attachment"
                          title={attachment.name}
                          onClick={() =>
                            params.downloadAttachment(attachment)
                          }
                        >
                          📎
                        </p>
                      ))}
                  </td>
                  <td>
                    {feedback.wantsToBeContacted ? (
                      <FormattedMessage
                        id={"app.feedback.influenced.yes"}
                      ></FormattedMessage>
                    ) : (
                      <FormattedMessage
                        id={"app.feedback.influenced.no"}
                      ></FormattedMessage>
                    )}
                  </td>
                  <td>
                    {feedback.feedbackStatus.type !== "none" && (
                      <FormattedMessage
                        id={
                          "app.feedback.status." +
                          feedback.feedbackStatus.type
                        }
                        defaultMessage="unknown"
                        key={i}
                      ></FormattedMessage>
                    )}
                    {feedback.feedbackStatus.type === "error" && (
                      <p>{feedback.feedbackStatus.errorDescription}</p>
                    )}
                    {feedback.feedbackStatus.type === "none" &&
                      params.role === config.get("adminRole") && (
                      <button
                        style={{ clear: "left", float: "left" }}
                        type="button"
                        className="btn btn-outline-secondary btn-xs"
                        data-toggle="modal"
                        onClick={() => params.sendToCask(feedback.id)}
                      >
                        <FormattedMessage id="app.feedback.cask.button" />
                      </button>
                    )}
                  </td>
                  <td>
                    <span
                      className="spanButton red"
                      onClick={() => params.deleteFeedback(feedback.id)}
                    >
                        🗑
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-5">
          <div
            className="dataTables_info"
            id="feedbackTable_info"
            role="status"
            aria-live="polite"
          >
            <FormattedMessage
              id="app.feedback.paging.result"
              values={{ start: startIndex, end: endIndex, count: params.count }}
            />
            {params.total !== params.count && (
              <FormattedMessage
                id="app.feedback.paging.filter"
                values={{ total: params.total }}
              />
            )}
          </div>
        </div>
        <div className="col-sm-12 col-md-7">
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="feedbackTable_paginate"
          >
            <ul className="pagination">
              {pageLinks.map((page, i) => (
                <li
                  key={"page_" + i}
                  className={"paginate_button page-item " + page.style}
                >
                  <button
                    id={"page" + page.value}
                    name="feedbackTable_page"
                    aria-controls="feedbackTable"
                    data-dt-idx={i}
                    tabIndex="0"
                    className="page-link"
                    onClick={params.reload}
                  >
                    {page.text}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Feedback;
